import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

export function PostFooter() {
  return (
    <footer className="mt-16 pt-8 border-t border-border">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <Link
          to="/blog"
          className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to all posts
        </Link>
      </div>
    </footer>
  )
}
